import { ApiResponse, TokenData, CancellationReason, SatisfactionReason } from '../models';
import * as http from './http';
import ApiService from './service';

export class SatisfactionReasonService extends ApiService {
  public async loadAllSatisfactionReason() {
    const url = `${this.apiDomain}/api/settings/customer-satisfaction-reasons`;

    const resposne = await http.get<ApiResponse<SatisfactionReason[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createSatisfactionReason(data: SatisfactionReason, id?: string) {
    const url = `${this.apiDomain}/api/settings/customer-satisfaction-reasons`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateSatisfactionReason(data: SatisfactionReason, id?: string) {
    const url = `${this.apiDomain}/api/settings/customer-satisfaction-reasons/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteSatisfactionReason(id?: string) {
    const url = `${this.apiDomain}/api/settings/customer-satisfaction-reasons/${id}`;

    const response = await http.remove<ApiResponse<SatisfactionReason>>(
      url,
      this.store
    );
    return response.data;
  }
}
